{
  "nativeNotifications.permissionDenied": "Android bildirim izni kapalı; uygulama içi hatırlatıcılar burada görünmeye devam eder.",
  "nativeNotifications.permissionEnabled": "Android bildirimleri açık",
  "nativeNotifications.permissionPrompt": "Zamanı gelen hatırlatıcıları Android bildirimi olarak da göster.",
  "nativeNotifications.permissionUnsupported": "Bu Android cihaz sistem bildirimlerini gösteremiyor; uygulama içi hatırlatıcılar burada görünmeye devam eder.",
  "nativeActions.title": "Hatırlatıcı eylemi",
  "nativeActions.description": "Exognitos bir şeyi değiştirmeden önce en güncel sunucu durumunu gözden geçir.",
  "nativeActions.reviewTitle": "Eylemi onayla",
  "nativeActions.invalid": "Bu bildirim eylemi kullanılamıyor",
  "nativeActions.invalidDescription": "Sınırlı kimlik veya sürüm bilgisi eksik. Güncel hatırlatıcıyı incelemek için Bildirimler'i aç.",
  "nativeActions.taskUnavailable": "Bağlı görev yüklenemedi",
  "nativeActions.reminderOnly": "Bu eylem hatırlatıcı oluşumuna uygulanır.",
  "nativeActions.taskChanged": "Bu bildirim oluşturulduktan sonra görev değişti. Bunun yerine görevi açıp güncel durumu gözden geçir.",
  "nativeActions.actions": "Hatırlatıcı eylemleri",
  "nativeActions.complete": "Görevi tamamla",
  "nativeActions.snooze": "15 dakika ertele",
  "nativeActions.dismiss": "Hatırlatıcıyı kapat",
  "nativeActions.schedule": "Planlamayı aç",
  "nativeActions.back": "Bildirimler'e dön",
  "nativeActions.failed": "Eylem uygulanamadı. Güncel hatırlatıcı durumunu gözden geçirip yeniden dene.",
  "nativeActions.success.complete_task": "Görev tamamlandı.",
  "nativeActions.success.snooze_15m": "Hatırlatıcı 15 dakika ertelendi.",
  "nativeActions.success.acknowledge": "Hatırlatıcı kapatıldı."
}
